<template>
  <div v-shortkey="{ toggle: ['ctrl', 'h'] }" @shortkey="toggleModal">
    <modal :ctrl="modalCtrl">
      <h4 class="ui horizontal left aligned header">{{ $t('SHORTCUTS_GLOBAL') }}</h4>
      <div class="ui two column grid">
        <div class="column" v-for="(s, index) in globalShortcutsDisplayed" :key="index">
          <div class="ui two column grid middle aligned">
            <div class="row">
              <div class="five wide column">
                <div class="ui basic small label">{{ s.shortcut }}</div>
              </div>
              <div class="eleven wide column">{{ s.action }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="localShortcutsDisplayed.length !== 0">
        <h4 id="localShortcutsHeader" class="ui horizontal left aligned header">
          {{ $t('SHORTCUTS_WINDOW') }}
        </h4>
        <div class="ui two column grid">
          <div class="column" v-for="(s, index) in localShortcutsDisplayed" :key="index">
            <div class="row">
              <div class="ui two column grid">
                <div class="five wide column">
                  <div class="ui basic small label">{{ s.shortcut }}</div>
                </div>
                <div class="eleven wide column">{{ s.action }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<style lang="scss" scoped>
h4 {
  margin-bottom: 2em !important;
}

h4#localShortcutsHeader {
  margin-top: 2em !important;
}
</style>

<script>
// @flow
import Vue from 'vue'
import { ModalController } from '../Modal/Modal'
import Modal from '../Modal/Modal'

export default {
  props: ['text'],

  components: { Modal },

  data() {
    return {
      isShown: false,
      globalShortcuts: [
        { shortcutUniversal: '^ H', action: 'SHOW_HELP' },
        { shortcutUniversal: '^ G', action: 'GLOBAL_SEARCH' },
        { shortcutUniversal: '^ S', action: 'UPDATE_HELP' }
      ],
      localShortcuts: [],
      osType: 'UNKNOWN',
      modalCtrl: new ModalController({ header: this.$i18n.tc('SHORTCUT', 2) })
    }
  },
  computed: {
    globalShortcutsDisplayed() {
      return this.mapShortcuts(this.globalShortcuts)
    },
    localShortcutsDisplayed() {
      return this.mapShortcuts(this.localShortcuts)
    }
  },
  methods: {
    toggleModal(event) {
      switch (event.srcKey) {
        case 'toggle':
          this.defineLocalShortcuts()
          this.modalCtrl.toggle()
          break
      }
    },

    defineLocalShortcuts() {
      const currentRouteMeta = this.$router.currentRoute.meta
      if (currentRouteMeta && currentRouteMeta.shortcuts) {
        this.localShortcuts = currentRouteMeta.shortcuts
      } else {
        this.localShortcuts = []
      }
    },
    mapShortcuts(shortcuts) {
      return shortcuts.map(s => {
        return {
          action: this.$i18n.t(s.action),
          shortcut: this.mapShortcutAccordingToOsType(s)
        }
      })
    },
    mapShortcutAccordingToOsType(shortcut) {
      return (
        shortcut.shortcutUniversal ||
        (this.osType === 'WIN'
          ? shortcut.shortcutWin
          : this.osType === 'MAC'
          ? shortcut.shortcutMac
          : shortcut.shortcutWin + ' / ' + shortcut.shortcutMac)
      )
    }
  },

  created() {
    const navigator = window.navigator
    if (navigator.appVersion.indexOf('Win') !== -1) this.osType = 'WIN'
    if (navigator.appVersion.indexOf('Mac') !== -1) this.osType = 'MAC'
  }
}
</script>
